import "./styles.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Button from "../Button/Button";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useConfig } from "../../context/ConfigContext";
import { IoChevronBackOutline } from "react-icons/io5";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const Email = ({ onSendEmail, onSkip, onBackClick }) => {
  const { t } = useTranslation("questionsModule");
  const { uid } = useUID();
  const trackEvent = useAmplitude();
  const { userEmail, setUserEmail } = useConfig();

  useEffect(() => {
    trackEvent("webapp_user_visited_email_page", uid);
  }, [uid, trackEvent]);

  return (
    <div className="email-module">
      <div className="email-module-nav">
        <div className="email-module-back-button-wrapper">
          <IoChevronBackOutline
            className="email-module-back-icon"
            onClick={onBackClick}
          />
        </div>
      </div>
      <div className="email-module-header">
        <h4 className="email-title">{t("email-title")}</h4>
        <p className="email-info">{t("email-detail")}</p>
      </div>
      <div className="email-module-input-wrapper">
        <input
          type="text"
          placeholder={t("email-placeholder")}
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          className="email-input-field"
        />
      </div>
      <div className="email-module-btn-wrapper-top">
        <Button
          text={t("email-skip")}
          onClick={onSkip}
          alternateColor={false}
          usePrimaryColor={false}
          hideButtonBorder={true}
        />
      </div>
      <div className="email-module-btn-wrapper-bottom">
        <Button
          text={t("email-continue")}
          onClick={() => onSendEmail()}
          disabled={!emailRegex.test(userEmail)}
          alternateColor={true}
        />
      </div>
    </div>
  );
};
